import { useState } from "react";
import {
  Modal,
  ModalContent,
  ModalFooter,
  ModalTitle,
  Button,
  FileInput,
} from "suomifi-ui-components";
import styled from "styled-components";
import { useTranslation } from "react-i18next";

interface Props {
  visible: boolean;
  onConfirm: (files: {
    dokumenttiEtupuoli?: File;
    dokumenttiTakapuoli?: File;
    selfie?: File;
  }) => void;
  onCancel: () => void;
}

const FileInputWrapper = styled.div`
  margin-bottom: ${({ theme }) => theme.spacing.m};
`;

export default function KuvatModal({
  visible,
  onConfirm,
  onCancel,
}: Props) {
  const { t } = useTranslation("manuaaliProsessi");
  const [dokumenttiEtupuoli, setDokumenttiEtupuoli] = useState<File | null>(null);
  const [dokumenttiTakapuoli, setDokumenttiTakapuoli] = useState<File | null>(null);
  const [selfie, setSelfie] = useState<File | null>(null);

  function handleConfirm() {
    onConfirm({
      dokumenttiEtupuoli: dokumenttiEtupuoli ?? undefined,
      dokumenttiTakapuoli: dokumenttiTakapuoli ?? undefined,
      selfie: selfie ?? undefined,
    });
    handleCancel();
  }

  function handleCancel() {
    setDokumenttiEtupuoli(null);
    setDokumenttiTakapuoli(null);
    setSelfie(null);
    onCancel();
  }

  return (
    <Modal
      appElementId="root"
      visible={visible}
      onEscKeyDown={handleCancel}
      scrollable={false}
    >
      <ModalContent>
        <ModalTitle>{t("titles.kuvat")}</ModalTitle>

        <FileInputWrapper>
          <FileInput
            labelText="Asiakirjan etupuoli"
            accept="image/*,.pdf"
            inputButtonText="Valitse tiedosto"
            dragAreaText="Raahaa tiedosto tähän"
            removeFileText="Poista tiedosto"
            addedFileAriaText="Lisätty tiedosto"
            onChange={(files) => {
              if (files?.length) setDokumenttiEtupuoli(files[0]);
            }}
          />
          {dokumenttiEtupuoli && (
            <div style={{ fontSize: "0.75rem", marginTop: "0.5rem" }}>
              {dokumenttiEtupuoli.name}
            </div>
          )}
        </FileInputWrapper>

        <FileInputWrapper>
          <FileInput
            labelText="Asiakirjan takapuoli"
            accept="image/*,.pdf"
            inputButtonText="Valitse tiedosto"
            dragAreaText="Raahaa tiedosto tähän"
            removeFileText="Poista tiedosto"
            addedFileAriaText="Lisätty tiedosto"
            onChange={(files) => {
              if (files?.length) setDokumenttiTakapuoli(files[0]);
            }}
          />
          {dokumenttiTakapuoli && (
            <div style={{ fontSize: "0.75rem", marginTop: "0.5rem" }}>
              {dokumenttiTakapuoli.name}
            </div>
          )}
        </FileInputWrapper>

        <FileInputWrapper>
          <FileInput
            labelText="Selfie-kuva"
            accept="image/*,.pdf"
            inputButtonText="Valitse tiedosto"
            dragAreaText="Raahaa tiedosto tähän"
            removeFileText="Poista tiedosto"
            addedFileAriaText="Lisätty tiedosto"
            onChange={(files) => {
              if (files?.length) setSelfie(files[0]);
            }}
          />
          {selfie && (
            <div style={{ fontSize: "0.75rem", marginTop: "0.5rem" }}>
              {selfie.name}
            </div>
          )}
        </FileInputWrapper>
      </ModalContent>

      <ModalFooter>
        <Button onClick={handleConfirm}>Lataa kuvat</Button>
        <Button variant="secondary" onClick={handleCancel}>
          Peruuta
        </Button>
      </ModalFooter>
    </Modal>
  );
}